module.exports = __webpack_public_path__ + "static/media/food.049d4640.jpg";